import { SECONDARY_COLOR } from "../constants/colors";

interface Props {
    value: string
}

const ShipmentMethodRiderDetail = ({ value }: Props) => {
    return <span style={{
        backgroundColor: SECONDARY_COLOR,
        color: '#fff',
        borderRadius: "6px",
        padding: "2px 8px",
        lineHeight: 3,
    }}>
        {value.length > 0 ? (value.length > 10 ? `${value.substring(0, 8)}...` : value) : "ໄລເດີ້ນອກ"}
    </span>

}
export default ShipmentMethodRiderDetail;